import type { TabItem } from './Tabs.js';
import { Tabs } from './Tabs.js';
import { cn } from '../../utils/cn.js';

interface EntityTabsProps {
  tabs: readonly TabItem[];
  active: string;
  onChange: (id: string) => void;
  className?: string;
}

/** Detail-page section tabs: the underline `Tabs` with the spacing a detail page puts under its header. */
export function EntityTabs({ tabs, active, onChange, className }: EntityTabsProps) {
  return <Tabs tabs={tabs} activeTab={active} onChange={onChange} className={cn('mb-4', className)} />;
}
